import type { UserAvatarProps } from "./user-avatar.type";
import type { AvatarProps } from "antd";

import { Tooltip, Avatar } from "antd";
import classNames from "classnames";

import {
  getUserAvatarStatusStyle,
  getUserAvatarText,
  getUserAvatarTooltip,
} from "./user-avatar.helper";

import "./user-avatar.style.less";

export const UserAvatar = ({
  ref,
  type = "acronym",
  user,
  statusColor,
  size,
  style,
  clickable,
  withTooltip,
  onClick,
}: UserAvatarProps) => {
  if (!user?.name) return null;

  const content = getUserAvatarText(type, user);
  const statusStyle = getUserAvatarStatusStyle(statusColor);

  const props: AvatarProps = {
    size,
    style: { ...statusStyle, ...style },
    className: classNames("user-avatar", {
      "-clickable": !!onClick || clickable,
    }),
    onClick,
  };

  const avatar = <Avatar {...props}>{content}</Avatar>;

  if (!withTooltip) return <span ref={ref}>{avatar}</span>;

  return (
    <Tooltip title={getUserAvatarTooltip(user)} placement="right">
      <span ref={ref}>{avatar}</span>
    </Tooltip>
  );
};
